import { Field, Form, Formik } from "formik";
import _ from "lodash";
import moment from "moment";
import { uniq } from "ramda";
import React, { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import SwiperCore, { A11y, Navigation, Pagination, Scrollbar } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import * as Yup from "yup";
import { client } from "../../../App";
import { ManageContainerClass } from "../../../helpers/customHooks";
import {
  CaseForms,
  ComplexCaseStatusEnum,
  UserRoleEnum,
} from "../../../helpers/enums";
import {
  dateRangeFilterFn,
  handlerErrors,
  isObject,
  ServiceLinkWithChildren,
  SwitchUser,
  TranslatedText,
} from "../../../helpers/helpers";
import {
  DELETE_PRACTICE,
  getEvictionForMutation,
} from "../../../helpers/mutations";
import {
  GET_CUSTOMER_CASES,
  GET_OPERATOR_CASES,
} from "../../../helpers/queries";
import { hideLoading, showLoading } from "../../../reducers/app";
import ActionPanel from "../../common/ActionPanel/ActionPanel";
import DataTable from "../../common/DataTable/DataTable";
import DisableBillModal from "../../common/DisableBillModal/DisableBillModal";
import FilterBox from "../../common/FiltersBox/FiltersBox";
import Hero from "../../common/Hero/Hero";
import NoResult from "../../common/NoResult/NoResult";
import "./ListCasePage.scss";
// Import Swiper styles
import i18n from "i18next";
import "swiper/components/navigation/navigation.scss";
import "swiper/swiper.scss";
import getMenuConfig from "../../../helpers/menuConfig";
import ArrowLink from "../../common/ArrowLink/ArrowLink";
import Loader from "../../common/Loader/Loader";
import Modal from "../../common/Modal/Modal";

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

const handleClick = (route) => {
  window.location.href = route;
};

const CaseWebUser = () => {
  return [
    {
      type: "new_delivery",
      translationKey: "listCase.newDelivery.title",
      cases: [
        {
          route: "voltura",
          translationKey: "voltura",
          type: "voltura",
        },
        {
          route: "subentro",
          translationKey: "subentro",
          type: "subentro",
        },
        {
          route: "allacciamento",
          translationKey: "allacciamento_acqua",
          type: "allacciamento_acqua",
        },
        {
          route: "allacciamento/fognatura",
          translationKey: "allacciamento_fognatura",
          type: "allacciamento_fognatura",
        },
      ],
    },
    {
      type: "new_costs_payments",
      translationKey: "listCase.newCostsAndPayments.title",
      cases: [
        {
          route: "domiciliazione-bancaria",
          translationKey: "domiciliazione_bancaria",
          type: "domiciliazione_bancaria",
        },
        {
          route: "avvenuto-pagamento",
          translationKey: "avvenuto_pagamento",
          type: "avvenuto_pagamento",
        },
        {
          route: "rateizzazione-bolletta",
          translationKey: "rateizzazione_bolletta",
          type: "rateizzazione_bolletta",
        },
        {
          route: "rettifica-fatturazione",
          translationKey: "rettifica_fatturazione",
          type: "rettifica_fatturazione",
        },
      ],
    },
    {
      type: "new_maintenance",
      translationKey: "listCase.newMaintenance.title",
      cases: [
        {
          route: "verifica-metrica",
          translationKey: "verifica_metrica",
          type: "verifica_metrica",
        },
        {
          route: "disattivazione-della-fornitura",
          translationKey: "disattivazione_della_fornitura",
          type: "disattivazione_della_fornitura",
        },
        {
          route: "verifica-contatore",
          translationKey: "verifica_contatore",
          type: "verifica_contatore",
        },
        {
          route: "verifica-della-pressione",
          translationKey: "verifica_della_pressione",
          type: "verifica_della_pressione",
        },
      ],
    },
    {
      type: "new_service_added",
      translationKey: "listCase.newService.title",
      cases: [
        {
          route: "lettura-sicura",
          translationKey: "lettura_sicura",
          type: "lettura-sicura",
        },
        {
          route: "tutela-perdite",
          translationKey: "tutela_perdite",
          type: "tutela_perdite",
        },
        {
          route: "preventivo-lavori",
          translationKey: "preventivo_lavori",
          type: "preventivo_lavori",
        },
        /*{
          route: "richiedi-omaggio",
          translationKey: "richiedi_omaggio",
          type: "richiedi_omaggio",
        },*/
        {
          route: "denuncia-perdite",
          translationKey: "denuncia_perdite",
          type: "denuncia_perdite",
        },
        {
          route: "modifica-dati",
          translationKey: "modifica_dati",
          type: "modifica_dati",
        },
      ],
    },
    {
      type: "network_interventions",
      translationKey: "listCase.new_network_interventions.title",
      cases: [
        {
          route: "estensione-rete-esistente",
          translationKey: "estensione_rete_esistente",
          type: "estensione_rete_esistente",
        },
        {
          route: "opere-di-urbanizzazione",
          translationKey: "opere_di_urbanizzazione",
          type: "opere_di_urbanizzazione",
        },
        {
          route: "/tracciamento-nuove-reti",
          translationKey: "tracciamento_reti",
          type: "tracciamento_reti",
        },
      ],
    },
  ];
};

const CaseOperatorMunicipalUser = () => {
  return [
    {
      route: "voltura",
      translationKey: "voltura",
      type: "voltura",
    },
    {
      route: "subentro",
      translationKey: "subentro",
      type: "subentro",
    },
    {
      route: "estensione-rete-esistente",
      translationKey: "estensione_rete_esistente",
      type: "estensione_rete_esistente",
    },
    {
      route: "disattivazione-della-fornitura",
      translationKey: "disattivazione_della_fornitura",
      type: "disattivazione_della_fornitura",
    },
    {
      route: "preventivo-lavori",
      translationKey: "preventivo_lavori",
      type: "preventivo_lavori",
    },
    {
      route: "verifica-contatore",
      translationKey: "verifica_contatore",
      type: "verifica_contatore",
    },
    {
      route: "allacciamento/fognatura",
      translationKey: "allacciamento_fognatura",
      type: "allacciamento_fognatura",
    },
    {
      route: "allacciamento",
      translationKey: "allacciamento_acqua",
      type: "allacciamento_acqua",
    },
    {
      route: "modifica-dati",
      translationKey: "modifica_dati",
      type: "modifica_dati",
    },
  ];
};

const getTypeCaseForUser = (role) => {
  switch (role) {
    case UserRoleEnum.PRIVATE:
    case UserRoleEnum.CONDOMINIUM_ADMIN:
    case UserRoleEnum.MUNICIPAL_USER:
    case UserRoleEnum.COMPANY:
      return CaseWebUser();
    case UserRoleEnum.MUNICIPAL_OPERATOR:
      return CaseOperatorMunicipalUser();
    default:
      return [];
  }
};

const TypeCases = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  let initialValues = { cases: null };
  const schemaValidation = Yup.object().shape({
    cases: Yup.string().required(
      <TranslatedText i18nKey="listCasePage.submit.error" />
    ),
  });
  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize={true}
      validationSchema={schemaValidation}
      key={"typeCasesList"}
      onSubmit={(values) => {
        const route = _.reduce(
          values,
          function (result, value, key) {
            return value;
          },
          []
        );
        const body = document?.querySelector("body");
        if (body) {
          body.classList.remove("modal-open");
        }
        history.push(`/${route}`);
      }}
    >
      {({ isValid }) => (
        <Form autoComplete="off" role="presentation">
          <div className="row">
            <div className="col-12 text-md-center text-sm-center">
              <h1 className={"title font-bold"}>
                {t("listCasePage.new_case_popup.title")}
              </h1>
              <p className={"subtitle"}>
                {t("listCasePage.new_case_popup.subtitle")}
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-12 text-sm-left">
              <ul>
                {props.cases.map((typeCase, i) => {
                  return (
                    <li className={"text-sm-left"} key={`${i}_case`}>
                      <div className="form-check abc-radio">
                        <Field
                          className="form-check-input"
                          type="radio"
                          name={"cases"}
                          id={`${typeCase.type}_${i}`}
                          value={typeCase.route}
                        />
                        <label
                          className="form-check-label text"
                          htmlFor={`${typeCase.type}_${i}`}
                        >
                          {t(`listCasePage.case.li.${typeCase.translationKey}`)}
                        </label>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              {!isValid ? (
                <div className="invalid-feedback">
                  {t("listCasePage.submit.error")}
                </div>
              ) : null}
            </div>
          </div>
          <div className="row buttons-space">
            <div className="buttons order-2">
              <button
                className={"btn btn-secondary"}
                type={"button"}
                onClick={() => props.setOpenSelectCase(false)}
              >
                {" "}
                {t("listCasePage.new_case_popup.btn.back")}
              </button>
            </div>
            <div className="buttons order-1">
              <button className={"btn btn-primary"} type={"submit"}>
                {" "}
                {t("listCasePage.new_case_popup.btn.go")}
              </button>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

const ProviderCase = (props) => {
  const role = props.role;
  const cases =
    getTypeCaseForUser(role).length > 0
      ? getTypeCaseForUser(role)
      : props.setOpenSelectCase(false);
  return (
    <div>
      <TypeCases cases={cases} setOpenSelectCase={props.setOpenSelectCase} />
    </div>
  );
};

const ListCaseTable = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();

  const [selectedRows, setSelectedRowsIds] = useState({});
  const [clickedRowIndex, setClickedRow] = useState(null);
  const { items, filterMode, filtredItems, isRolePrivate } = props;
  const [dataToRender, setDataRender] = useState([]);
  const [cancelModal, setCancelModal] = useState(false);
  const [selectedItem, setItemSelected] = useState({});
  const [genericError, setGenericError] = useState(null);

  const [dataToRenderWithTypes, setDataToRenderWithTypes] = useState();

  useEffect(() => {
    const data = dataToRender.map((item) => {
      return {
        ...item,
        status: item.status
          ? t(`cases.status.${ComplexCaseStatusEnum[item.status]}`)
          : t(`cases.status.NOT_SPECIFIED`),
        type: item.type
          ? t(`cases.names.${item.type}`)
          : t(`cases.names.NOT_SPECIFIED`),
      };
    });
    setDataToRenderWithTypes(data);
  }, [dataToRender, t]);

  useEffect(() => {
    setDataRender(
      _.orderBy(filterMode ? filtredItems : items, ["issueDate"], ["desc"])
    );
    // eslint-disable-next-line
  }, [items, filtredItems]);

  const tableMarginTop = isRolePrivate ? "margin-top" : "";

  const leftCtaIcon = isRolePrivate
    ? "gc-icon-functional-doc-pdf-1-col"
    : "gc-icon-functional-arrow-right";

  const columns = React.useMemo(
    () => [
      {
        // Make an expander cell
        Header: () => null,
        id: "checkBox", // It needs an ID
        accessor: "expander",
        Cell: ({ row, getToggleAllRowsSelectedProps }) => {
          const activeButtonType = [
            CaseForms.Allaccio,
            CaseForms.Fognatura,
            CaseForms.Voltura,
            CaseForms.Subentro,
            CaseForms.TutelaPerdite,
            CaseForms.DenunciaPerdite,
            CaseForms.DomiciliazioneBancariaComplex,
            CaseForms.VolturaMortisCausa,
          ];
          const { original } = row;
          const { current_status, current_type } = original;
          const p = row.getToggleRowSelectedProps();
          delete p.indeterminate;
          delete p.title;
          return (
            <>
              {current_status !== ComplexCaseStatusEnum.DELETED ? (
                activeButtonType.includes(current_type) ? (
                  <label className="container-checkbox">
                    <input
                      {...p}
                      type="radio"
                      name="selectedContract"
                      id={`radio-${row.id}`}
                      onChange={(e) => {
                        p.onChange(e);
                        setClickedRow(row.id);
                      }}
                      aria-label={
                        t("select.contract.table") + " " + row.original.caseId
                      }
                    />
                    <span className="checkmark checkmark-radio" />
                  </label>
                ) : null
              ) : null}
            </>
          );
        },
      },
      {
        Header: t("cases.panel.table.headerId"),
        accessor: "caseId",
        id: 1,
      },
      {
        Header: t("cases.panel.table.headerDateAdded"),
        accessor: "issueDate",
        id: 2,
        Cell: ({ row }) => {
          return moment(row.allCells[2].value).format("DD-MM-YYYY");
        },
      },
      {
        Header: t("cases.panel.table.headerType"),
        accessor: "type",
        id: 3,
      },
      {
        Header: t("cases.panel.table.relatedContractCode"),
        accessor: "contractId",
        id: 4,
      },
      {
        Header: t("cases.panel.table.fiscalCode"),
        accessor: "fiscalCode",
        id: 5,
      },
      {
        Header: t("cases.panel.table.ownerName"),
        accessor: "ownerName",
        id: 6,
      },

      {
        Header: t("cases.panel.table.headerStatus"),
        accessor: "status",
        id: 7,
      },
    ],
    // eslint-disable-next-line
    [t]
  );

  const operatorMuncipalColumns = React.useMemo(
    () => [
      {
        // Make an expander cell
        Header: () => null,

        id: "checkBox", // It needs an ID
        accessor: "expander",
        Cell: ({ row, getToggleAllRowsSelectedProps }) => {
          const activeButtonType = [
            CaseForms.Allaccio,
            CaseForms.Fognatura,
            CaseForms.Voltura,
            CaseForms.Subentro,
            CaseForms.TutelaPerdite,
            CaseForms.DenunciaPerdite,
            CaseForms.DomiciliazioneBancariaComplex,
          ];
          const p = row.getToggleRowSelectedProps();
          const { original } = row;
          const { current_status, current_type } = original;
          delete p.indeterminate;
          delete p.title;

          return (
            <>
              {current_status !== ComplexCaseStatusEnum.DELETED ? (
                activeButtonType.includes(current_type) ? (
                  <label className="container-checkbox">
                    <input
                      {...p}
                      type="radio"
                      name="selectedContract"
                      id={`radio-${row.id}`}
                      onChange={(e) => {
                        p.onChange(e);
                        setItemSelected(row.original);
                        setClickedRow(row.id);
                      }}
                      aria-label={
                        t("select.contract.table") + " " + row.original.caseId
                      }
                    />
                    <span className="checkmark checkmark-radio" />
                  </label>
                ) : null
              ) : null}
            </>
          );
        },
      },
      {
        Header: t("cases.panel.table.headerId"),
        accessor: "caseId",
        id: 1,
      },
      {
        Header: t("cases.panel.table.headerType"),
        accessor: "type",
        id: 2,
      },
      {
        Header: t("cases.panel.table.headerStatus"),
        accessor: "status",
        id: 3,
      },
      {
        Header: t("cases.panel.table.headerDateAdded"),
        accessor: "issueDate",
        id: 4,
        Cell: ({ row }) => {
          return moment(row.allCells[4].value).format("DD-MM-YYYY");
        },
      },
      {
        Header: t("cases.panel.table.headerEmail"),
        accessor: "fiscalCode",
        id: 5,
      },
    ],
    // eslint-disable-next-line
    [t]
  );

  const keysToDisable = isRolePrivate
    ? ["draftAsJson", "subType", "draft"]
    : [];

  const columnsTOrender = isRolePrivate ? columns : operatorMuncipalColumns;
  const [selectedIndex] = Object.keys(selectedRows);
  const selectedRow = dataToRender[selectedIndex];
  const getActions = () => {
    const actions = [];
    const allowedToResumeTypes = [
      CaseForms.Allaccio,
      CaseForms.Fognatura,
      CaseForms.Voltura,
      CaseForms.Subentro,
      CaseForms.TutelaPerdite,
      CaseForms.DomiciliazioneBancariaComplex,
    ];
    const allowedToDownloadTypes = [
      CaseForms.Allaccio,
      CaseForms.Fognatura,
      CaseForms.Voltura,
      CaseForms.Subentro,
      CaseForms.TutelaPerdite,
      CaseForms.DenunciaPerdite,
      CaseForms.DomiciliazioneBancariaComplex,
    ];

    if (selectedRow && selectedRow.draft) {
      if (selectedRow.status === ComplexCaseStatusEnum.NOT_COMPLETED) {
        const cancelButton = {
          onCLick: () => {
            setCancelModal(true);
          },
          label: t("cases.panel.cta.cancel"),
          icon: <i className="gc-icon-functional-close" aria-hidden="true" />,
          link: "",
        };
        const resumeButton = {
          onCLick: () => {},
          label: t("cases.panel.cta.continueProcedure"),
          icon: (
            <i className="gc-icon-functional-arrow-right" aria-hidden="true" />
          ),
          link: `/area-riservata/cases/${selectedRow.current_caseId}`,
        };

        if (
          selectedRow.type &&
          allowedToResumeTypes.includes(selectedRow.type)
        ) {
          if (!isRolePrivate) {
            actions.push(cancelButton);
          }
          actions.push(resumeButton);
        }
      }
    }

    if (allowedToDownloadTypes.includes(selectedRow.type)) {
      if (selectedRow.path && selectedRow !== "") {
        const downloadButton = {
          onCLick: () => {
            const link = document.createElement("a");
            link.href = selectedRow.path;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          },
          label: t("cases.panel.cta.downloadBill"),
          icon: <i className={leftCtaIcon} aria-hidden="true"></i>,
          link: "",
        };
        actions.push(downloadButton);
      }
    }

    return actions;
  };

  const handleGenericError = () => {
    let error = isObject(genericError)
      ? genericError[Object.keys(genericError)[0]]
      : genericError;

    let formatedError = error.includes("_")
      ? t(`associate-contact.${error}`)
      : t(`${error}`);

    return (
      <div className={"row"}>
        <div className={"container"}>
          <div className="col-sm-12 mt-5">
            <div className={"generic-error d-flex justify-content-start"}>
              <i
                className="gc-icon-functional-attention-1-col"
                aria-hidden="true"
              ></i>
              <p>{formatedError}</p>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const deletePractica = async () => {
    // console.log(selectedItem);
    setCancelModal(false);
    try {
      dispatch(showLoading());
      const { data } = await client().mutate({
        mutation: DELETE_PRACTICE,
        variables: {
          req: {
            caseId: selectedItem.current_caseId,
            safoAccountId: selectedItem.current_operator_id,
          },
        },
        update: (cache) => {
          const fieldsToEvict = getEvictionForMutation("deleteCase");
          fieldsToEvict.forEach((field) => cache.evict({ fieldName: field }));
          cache.gc();
        },
      });
      if (data && data.deleteCase && data.deleteCase.outcome) {
        props.setRemovedItem(true);
        dispatch(hideLoading());
        history.push("/");
      }
    } catch (e) {
      handlerErrors(e, setGenericError, setGenericError);
      dispatch(hideLoading());
    }
  };

  const keysOrder = isRolePrivate
    ? [
        "caseId",
        "issueDate",
        "type",
        "contractId",
        "fiscalCode",
        "ownerName",
        "status",
      ]
    : ["ownerSurname"];
  return (
    <>
      <div
        className={`row data-table-holder ${tableMarginTop} ${
          !dataToRender?.length ? "noresult-active" : ""
        }`}
      >
        {dataToRender && dataToRender.length > 0 ? (
          <DataTable
            excludeKeys={keysToDisable}
            setClickedRow={setClickedRow}
            singleCheckbox={clickedRowIndex}
            dtTable={[]}
            columns={columnsTOrender}
            columnOrder={keysOrder}
            data={dataToRenderWithTypes}
            selectedRowsIds={(e) => {
              setSelectedRowsIds(e);
            }}
          />
        ) : (
          <NoResult text={t("usage.empty.text")} />
        )}
        {dataToRender && selectedRows && Object.keys(selectedRows).length ? (
          <div className="container action-panel-holder">
            <ActionPanel
              onClick={() => console.log("Handle contnue")}
              selectedRows={selectedRows}
              actions={getActions()}
            />
          </div>
        ) : null}

        {cancelModal ? (
          <DisableBillModal
            header={t("cases.panel.cta.cancel")}
            title={t("delete.practic.description.text")}
            icon={"gc-icon-functional-close-circle-2-col"}
            btnCancel={t("button.cancel").toUpperCase()}
            btnConfirm={t("button.confirm").toUpperCase()}
            isOpen={true}
            disable={() => deletePractica()}
            onClose={() => setCancelModal(false)}
            to={"/"}
          />
        ) : null}
        {genericError && handleGenericError()}
      </div>
    </>
  );
};

const ListCaseContentWebUser = (props) => {
  const { t } = useTranslation();
  const [filtredItems, setFilteredItems] = useState([]);
  const [filterMode, toggleFilterMode] = useState(false);
  const current = useSelector((state) => state.contracts.current);
  const { viewCases } = getMenuConfig();
  // eslint-disable-next-line
  const currentContract = current ? current.id : null;

  // eslint-disable-next-line
  const [filters, setFilters] = useState({});
  const [typology, setTypology] = useState(null);
  const [status, setStatus] = useState(null);
  let filterConfigData = {
    fields: [
      {
        name: "id_practic",
        type: "input",
        label: t("cases.panel.filter.id.label"),
        placeholder: t("cases.panel.filter.id.placeholder"),
        columnSize: "3",
      },
      {
        label: t("cases.panel.filter.typology.label"),
        name: "typology",
        type: "select",
        columnSize: "3",
        placeholder: t("cases.panel.filter.typology.placeholder"),
        options: typology,
      },
      {
        name: "status",
        type: "select",
        label: t("cases.panel.filter.status.label"),
        columnSize: "3",
        placeholder: t("cases.panel.filter.status.placeholder"),
        options: status,
      },
      // {
      //   label: t("cases.panel.filter.statusExpiration.label"),
      //   name: "expiration_status",
      //   type: "select",
      //   columnSize: "3",
      //   placeholder: t("cases.panel.filter.statusExpiration.placeholder"),
      //   options: [
      //     { label: "Tutte", value: "ALL" },
      //     { label: "Option", value: "option" },
      //     { label: "Option 2", value: "option2" },
      //   ],
      // },
      {
        name: "surname",
        type: "input",
        label: t("cases.panel.filter.requestSurname.label"),
        placeholder: t("cases.panel.filter.requestSurname.placeholder"),
        columnSize: "3",
      },
      {
        label: t("cases.panel.filter.from.label"),
        name: "startD",
        type: "date",
        columnSize: "3",
        placeholder: t("cases.panel.filter.from.placeholder"),
      },
      {
        label: t("cases.panel.filter.to.label"),
        name: "endD",
        type: "date",
        columnSize: "3",
        placeholder: t("cases.panel.filter.from.placeholder"),
      },
      {
        label: t("bills.filters.contract"),
        name: "contract",
        type: "contractDropDown",
        leftIcon: "lens",
        columnSize: "3",
        usages: false,
      },
    ],
    validations: [],
    configuration: {
      hasReset: true,
    },
  };

  useEffect(() => {
    let filterConfigData = {
      fields: [
        {
          name: "id_practic",
          type: "input",
          label: t("cases.panel.filter.id.label"),
          placeholder: t("cases.panel.filter.id.placeholder"),
          columnSize: "3",
        },
        {
          label: t("cases.panel.filter.typology.label"),
          name: "typology",
          type: "select",
          columnSize: "3",
          placeholder: t("cases.panel.filter.typology.placeholder"),
          options: typology,
        },
        {
          name: "status",
          type: "select",
          label: t("cases.panel.filter.status.label"),
          columnSize: "3",
          placeholder: t("cases.panel.filter.status.placeholder"),
          options: status,
        },
        // {
        //   label: t("cases.panel.filter.statusExpiration.label"),
        //   name: "expiration_status",
        //   type: "select",
        //   columnSize: "3",
        //   placeholder: t("cases.panel.filter.statusExpiration.placeholder"),
        //   options: [
        //     { label: "Tutte", value: "ALL" },
        //     { label: "Option", value: "option" },
        //     { label: "Option 2", value: "option2" },
        //   ],
        // },
        {
          name: "surname",
          type: "input",
          label: t("cases.panel.filter.requestSurname.label"),
          placeholder: t("cases.panel.filter.requestSurname.placeholder"),
          columnSize: "3",
        },
        {
          label: t("cases.panel.filter.from.label"),
          name: "startD",
          type: "date",
          columnSize: "3",
          placeholder: t("cases.panel.filter.from.placeholder"),
        },
        {
          label: t("cases.panel.filter.to.label"),
          name: "endD",
          type: "date",
          columnSize: "3",
          placeholder: t("cases.panel.filter.from.placeholder"),
        },
        {
          label: t("bills.filters.contract"),
          name: "contract",
          type: "contractDropDown",
          leftIcon: "lens",
          columnSize: "3",
          usages: false,
        },
      ],
      validations: [],
      configuration: {
        hasReset: true,
      },
    };
    setFilterConfig(filterConfigData);
  }, [status, t, typology]);

  const [filterConfig, setFilterConfig] = useState(filterConfigData);
  const onFiltersChanged = (e) => {
    const { id_practic, typology, status, surname, startD, endD } = e;

    if (!id_practic && !typology && !status && !surname && !startD && !endD) {
      setFilters({});
      toggleFilterMode(false);
    } else {
      setFilters(e);
      toggleFilterMode(true);
    }
  };

  const [width] = ManageContainerClass();

  const marginLarge = (width - 1140) / 2 - 15;
  const cardsWidth = width < 420 ? 315 : 350;
  const spaceBetween = width < 420 ? 15 : 30;

  let margin = width > 1199 ? marginLarge : 0;

  const onSwiperInitAndClick = (s) => {
    s.activeIndex === 0 ? setMarginLeft(false) : setMarginLeft(true);

    if (width < 991) {
      s.activeIndex < s.slides.length - 1
        ? hideNextArrow(true)
        : hideNextArrow(false);
    } else if (width < 1199) {
      s.activeIndex < s.slides.length - 2
        ? hideNextArrow(true)
        : hideNextArrow(false);
    } else {
      s.activeIndex < s.slides.length - 3
        ? hideNextArrow(true)
        : hideNextArrow(false);
    }
  };

  const [firstIndex, setMarginLeft] = useState("");
  const [nextArrow, hideNextArrow] = useState("");

  const { data, dataLoaded } = props;

  useEffect(() => {
    console.log("status and typology calculations");

    if (data && data.length) {
      const types = data.map((item) => {
        return {
          label: item.type
            ? t(`cases.names.${item.type}`)
            : t(`cases.names.NOT_SPECIFIED`),
          value: item.type,
        };
      });
      const status = data.map((item) => {
        return {
          label: ComplexCaseStatusEnum[item.status]
            ? t(`cases.status.${ComplexCaseStatusEnum[item.status]}`)
            : t(`cases.status.NOT_SPECIFIED`),
          value: item.status,
        };
      });
      const removeDuplicates = uniq(
        [{ label: t("Tutte"), value: "ALL" }, ...types].filter(
          ({ label }) => label
        )
      );
      const removeDuplicatesStatus = uniq(
        [{ label: t("Tutte"), value: "ALL" }, ...status].filter(
          ({ label }) => label
        )
      );
      const configs = filterConfig.fields.map((el) => {
        if (el.name === "typology") {
          return {
            ...el,
            options: removeDuplicates,
          };
        }
        if (el.name === "status") {
          return {
            ...el,
            options: removeDuplicatesStatus,
          };
        }
        return { ...el };
      });

      setFilterConfig({
        fields: configs,
        validations: [],
        configuration: {
          hasReset: true,
        },
      });

      setTypology(uniq(types));
      setStatus(uniq(status));
    }
    // eslint-disable-next-line
  }, [data, i18n.language]);
  return (
    <>
      <Hero
        helpText={t("listCasePage.modal.title")}
        backTo={"/"}
        backToText={t("common.back.home")}
        title={t("listCasePage.header")}
        description={
          <div>
            <>
              <Trans i18nKey="listCasePage.content">
                <ServiceLinkWithChildren
                  linkObject={{ link: viewCases, target: "_blank" }}
                />
              </Trans>
            </>
          </div>
        }
      />
      {typology && (
        <FilterBox
          config={filterConfig}
          onChange={onFiltersChanged}
          data={props.data}
          onDataFiltered={setFilteredItems}
          filter={(items, filters) => {
            const { id_practic, typology, status, surname, startD, endD } =
              filters;
            if (
              !id_practic &&
              !typology &&
              !status &&
              !surname &&
              !startD &&
              !endD
            ) {
              return items;
            }
            const typologyFn = (item, searchKey) => {
              if (item && searchKey) {
                return (
                  item.type &&
                  (item.type.toLowerCase() === searchKey.toLowerCase() ||
                    searchKey.toLowerCase() === "all")
                );
              }
              return true;
            };

            const idSearchFilterFn = (item, searchKey) => {
              if (item && searchKey) {
                return item.caseId
                  .toLowerCase()
                  .includes(searchKey.toLowerCase());
              }
              return true;
            };

            const statusFn = (item, searchKey) => {
              if (item && searchKey) {
                if (searchKey.toLowerCase() === "all") {
                  return true;
                }
                return !item.status
                  .toLowerCase()
                  .indexOf(searchKey.toLowerCase());
              }
              return true;
            };

            const surnameFn = (item, searchKey) => {
              if (item && searchKey) {
                return item.expirationStatus
                  .toLowerCase()
                  .includes(searchKey.toLowerCase());
              }
              return true;
            };
            // eslint-disable-next-line
            const contractFilter = (item, searchKey) => {
              if (item && searchKey) {
                return item.contractId
                  .toLowerCase()
                  .includes(searchKey.toLowerCase());
              }
              return true;
            };

            return items.filter((item) => {
              return (
                idSearchFilterFn(item, id_practic) &&
                typologyFn(item, typology) &&
                statusFn(item, status) &&
                surnameFn(item, surname) &&
                dateRangeFilterFn(item, startD, endD)
              );
            });
          }}
        />
      )}
      <div className="container component">
        <div className="row">
          <div className="col-sm-12 col-md-12">
            <h2 className="search-title">{t("cases.panel.casesRunning")}</h2>
          </div>
        </div>
      </div>
      <div>
        <div className="container component">
          {dataLoaded ? (
            <ListCaseTable
              filterMode={filterMode}
              filtredItems={filtredItems}
              items={props.data}
              isRolePrivate={true}
            />
          ) : (
            <Loader />
          )}
        </div>
      </div>
      <section className="gcap-carousel-section">
        <div className="container">
          <h2 id="sliderList" className="search-title gcap-carousel__title">
            {t("listCasePage.header.add.cases")}
          </h2>
        </div>

        <div
          className={`swiper-carousel-container ${
            nextArrow ? "" : "hide-next-arrow"
          } ${firstIndex ? "" : "margin-transition"}`}
          style={{ marginLeft: firstIndex ? 0 : margin }}
        >
          <Swiper
            onSlideChange={(s) => {
              onSwiperInitAndClick(s);
            }}
            onSwiper={(s) => {
              onSwiperInitAndClick(s);
            }}
            width={cardsWidth}
            navigation
            spaceBetween={spaceBetween}
          >
            {getTypeCaseForUser(props.role).map((c, index) => {
              return (
                <SwiperSlide key={index}>
                  <div
                    className="card"
                    key={index + c.type}
                    style={{
                      position: "relative",
                      width: cardsWidth,
                    }}
                  >
                    <div
                      className="card-inner"
                      key={c.type}
                      style={{ position: "relative" }}
                    >
                      <h1 className="card-inner--title">
                        {t(c.translationKey)}
                      </h1>
                      <div className="card-inner--container-link">
                        {c.cases.map((x) => (
                          <div key={x.type} className="card-inner--link">
                            <ArrowLink to={x.route} tabIndex={0}>
                              {t(`listCasePage.case.li.${x.translationKey}`)}
                            </ArrowLink>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </section>
    </>
  );
};

const ListCaseOperatorCommunal = (props) => {
  const { t } = useTranslation();
  const [filtredItems, setFilteredItems] = useState([]);
  const [filterMode, toggleFilterMode] = useState(false);

  // eslint-disable-next-line
  const [filters, setFilters] = useState({});
  const [typology, setTypology] = useState(null);
  const [status, setStatus] = useState(null);
  const { data, dataLoaded } = props;
  const filterConfigData = {
    fields: [
      {
        name: "id_practic",
        type: "input",
        label: <Trans i18nKey={"cases.panel.filter.id.label"} />,
        placeholder: t("cases.panel.filter.id.placeholder"),
        columnSize: "3",
      },
      {
        label: t("cases.panel.filter.typology.label"),
        name: "typology",
        type: "select",
        columnSize: "3",
        placeholder: t("cases.panel.filter.typology.placeholder"),
        options: typology,
      },
      // {
      //   name: "surname",
      //   type: "input",
      //   label: t("cases.panel.filter.requestSurname.label"),
      //   placeholder: t("cases.panel.filter.requestSurname.placeholder"),
      //   columnSize: "3",
      // },
      {
        label: t("cases.panel.filter.from.label"),
        name: "startD",
        type: "date",
        columnSize: "3",
        placeholder: t("cases.panel.filter.from.placeholder"),
      },
      {
        label: t("cases.panel.filter.to.label"),
        name: "endD",
        type: "date",
        columnSize: "3",
        placeholder: t("cases.panel.filter.from.placeholder"),
      },
      {
        name: "status",
        type: "select",
        label: t("cases.panel.filter.status.label"),
        columnSize: "3",
        placeholder: t("cases.panel.filter.status.placeholder"),
        options: status,
      },
    ],
    validations: [],
    configuration: {
      hasReset: true,
    },
  };
  const [filterConfig, setFilterConfig] = useState(filterConfigData);

  useEffect(() => {
    let filterConfigData = {
      fields: [
        {
          name: "id_practic",
          type: "input",
          label: t("cases.panel.filter.id.label"),
          placeholder: t("cases.panel.filter.id.placeholder"),
          columnSize: "3",
        },
        {
          label: t("cases.panel.filter.typology.label"),
          name: "typology",
          type: "select",
          columnSize: "3",
          placeholder: t("cases.panel.filter.typology.placeholder"),
          options: typology,
        },
        {
          name: "status",
          type: "select",
          label: t("cases.panel.filter.status.label"),
          columnSize: "3",
          placeholder: t("cases.panel.filter.status.placeholder"),
          options: status,
        },
        // {
        //   label: t("cases.panel.filter.statusExpiration.label"),
        //   name: "expiration_status",
        //   type: "select",
        //   columnSize: "3",
        //   placeholder: t("cases.panel.filter.statusExpiration.placeholder"),
        //   options: [
        //     { label: "Tutte", value: "ALL" },
        //     { label: "Option", value: "option" },
        //     { label: "Option 2", value: "option2" },
        //   ],
        // },
        {
          name: "surname",
          type: "input",
          label: t("cases.panel.filter.requestSurname.label"),
          placeholder: t("cases.panel.filter.requestSurname.placeholder"),
          columnSize: "3",
        },
        {
          label: t("cases.panel.filter.from.label"),
          name: "startD",
          type: "date",
          columnSize: "3",
          placeholder: t("cases.panel.filter.from.placeholder"),
        },
        {
          label: t("cases.panel.filter.to.label"),
          name: "endD",
          type: "date",
          columnSize: "3",
          placeholder: t("cases.panel.filter.from.placeholder"),
        },
        {
          label: t("bills.filters.contract"),
          name: "contract",
          type: "contractDropDown",
          leftIcon: "lens",
          columnSize: "3",
          usages: false,
        },
      ],
      validations: [],
      configuration: {
        hasReset: true,
      },
    };
    setFilterConfig(filterConfigData);
  }, [status, t, typology]);

  const onFiltersChanged = (e) => {
    const { id_practic, typology, status, surname, startD, endD } = e;

    if (!id_practic && !typology && !status && !surname && !startD && !endD) {
      setFilters({});
      toggleFilterMode(false);
    } else {
      setFilters(e);
      toggleFilterMode(true);
    }
  };
  useEffect(() => {
    if (data && data.length) {
      const types = data.map((item) => {
        return {
          label: item.type
            ? t(`cases.names.${item.type}`)
            : t(`cases.names.NOT_SPECIFIED`),
          value: item.type,
        };
      });
      const status = data.map((item) => {
        return {
          label: ComplexCaseStatusEnum[item.status]
            ? t(`cases.status.${ComplexCaseStatusEnum[item.status]}`)
            : t(`cases.status.NOT_SPECIFIED`),
          value: item.status,
        };
      });
      const removeDuplicates = uniq(
        [{ label: t("Tutte"), value: "ALL" }, ...types].filter(
          ({ label }) => label
        )
      );
      const removeDuplicatesStatus = uniq(
        [{ label: t("Tutte"), value: "ALL" }, ...status].filter(
          ({ label }) => label
        )
      );
      const configs = filterConfig.fields.map((el) => {
        if (el.name === "typology") {
          return {
            ...el,
            options: removeDuplicates,
          };
        }
        if (el.name === "status") {
          return {
            ...el,
            options: removeDuplicatesStatus,
          };
        }
        return { ...el };
      });
      setFilterConfig({
        fields: configs,
        validations: [],
        configuration: {
          hasReset: true,
        },
      });

      setTypology(uniq(types));
      setStatus(uniq(status));
    }
    return () => {};
    // eslint-disable-next-line
  }, [data]);
  return (
    <>
      <FilterBox
        config={filterConfig}
        onChange={onFiltersChanged}
        data={data}
        onDataFiltered={setFilteredItems}
        filter={(items, filters) => {
          const { id_practic, typology, status, surname, startD, endD } =
            filters;
          if (
            !id_practic &&
            !typology &&
            !status &&
            !surname &&
            !startD &&
            !endD
          ) {
            return items;
          }

          const typologyFn = (item, searchKey) => {
            if (item && searchKey) {
              if (item.type) {
                return (
                  item.type.toLowerCase() === searchKey.toLowerCase() ||
                  searchKey.toLowerCase() === "all"
                );
              }
            }
            return true;
          };

          const idSearchFilterFn = (item, searchKey) => {
            if (item && searchKey) {
              return item.caseId
                .toLowerCase()
                .includes(searchKey.toLowerCase());
            }
            return true;
          };

          const statusFn = (item, searchKey) => {
            if (item && searchKey) {
              if (searchKey.toLowerCase() === "all") {
                return true;
              }
              return item.status.toLowerCase().indexOf(searchKey.toLowerCase());
            }
            return true;
          };

          const surnameFn = (item, searchKey) => {
            if (item && searchKey) {
              return item.ownerSurname
                .toLowerCase()
                .includes(searchKey.toLowerCase());
            }
            return true;
          };

          return items.filter((item) => {
            return (
              idSearchFilterFn(item, id_practic) &&
              typologyFn(item, typology) &&
              statusFn(item, status) &&
              surnameFn(item, surname) &&
              dateRangeFilterFn(item, startD, endD)
            );
          });
        }}
      />
      <div className="container component">
        <div className="row">
          <div className="container-text-table">
            <p className={"font-bold"}>{t("listCasePage.listTable.title")}</p>
            <button
              className="container-data paragraph-main-fs8"
              onClick={() => props.setOpenSelectCase(true)}
            >
              {t("listCasePage.listTable.new_case")}
              <i
                className="gc-icon-functional-agreement-2-col"
                aria-hidden="true"
              >
                <span className="path1" />
                <span className="path2" />
              </i>
            </button>
          </div>
        </div>
        {dataLoaded ? (
          <ListCaseTable
            items={props.data}
            filterMode={filterMode}
            filtredItems={filtredItems}
            setRemovedItem={props.setRemovedItem}
          />
        ) : (
          <Loader />
        )}
      </div>
    </>
  );
};

const getContent = (
  role,
  data,
  setOpenSelectCase,
  setRemovedItem,
  dataLoaded = false
) => {
  if (role === UserRoleEnum.MUNICIPAL_OPERATOR) {
    return (
      <ListCaseOperatorCommunal
        data={data}
        dataLoaded={dataLoaded}
        setOpenSelectCase={setOpenSelectCase}
        setRemovedItem={setRemovedItem}
      />
    );
  } else {
    return (
      <ListCaseContentWebUser
        data={data}
        dataLoaded={dataLoaded}
        setOpenSelectCase={setOpenSelectCase}
        role={role}
      />
    );
  }
};

const ListCasePage = () => {
  const [openSelectCase, setOpenSelectCase] = useState(false);
  const user = useSelector((state) => state.auth);
  const userProfile = SwitchUser(user);
  const { role } = userProfile;
  const [cases, setCases] = useState([]);
  const [removedItem, setRemovedItem] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);

  useEffect(() => {
    let mounted = true;
    const getData = async () => {
      return client().query({
        query:
          role !== UserRoleEnum.MUNICIPAL_OPERATOR
            ? GET_CUSTOMER_CASES
            : GET_OPERATOR_CASES,
      });
    };
    getData()
      .then((results) => {
        setDataLoaded(true);
        const { data } = results;
        const { getCustomer = null, getOperator = null } = data;
        const { cases = null } =
          role !== UserRoleEnum.MUNICIPAL_OPERATOR ? getCustomer : getOperator;
        const { elements = null } = cases;
        if (elements && mounted) {
          if (role !== UserRoleEnum.MUNICIPAL_OPERATOR) {
            setCases(
              elements.map(
                ({
                  caseId,
                  caseNumber,
                  contract,
                  draft,
                  draftAsJson,
                  issueDate,
                  status,
                  subType,
                  type,
                  path,
                }) => {
                  return {
                    caseId: caseNumber,
                    current_caseId: caseId,
                    current_status: status,
                    current_type: type ? type : subType,
                    issueDate,
                    status,
                    subType,
                    type: type ? type : subType,
                    draftAsJson,
                    draft,
                    path,
                    contractId: contract.contractId || "",
                    ownerName:
                      (contract.accountHolder.name || "") +
                      " " +
                      (contract.accountHolder.surname || ""),
                    fiscalCode: contract.accountHolder.integraClientCode,
                  };
                }
              )
            );
          } else {
            setCases(
              elements.map(
                ({
                  caseId,
                  caseNumber,
                  type,
                  subType,
                  status,
                  contract,
                  issueDate,
                  operator,
                  draft,
                  path,
                }) => {
                  return {
                    caseId: caseNumber,
                    current_caseId: caseId,
                    current_operator_id: operator.id,
                    issueDate,
                    type: type ? type : subType,
                    current_status: status,
                    current_type: type ? type : subType,
                    status,
                    path,
                    ownerSurname: contract.accountHolder.surname || "",
                    fiscalCode: operator.email,
                    operatorId: operator.email,
                    draft,
                  };
                }
              )
            );
          }
        }
      })
      .catch((error) => console.log(error));
    return () => (mounted = false);
    /**
     if (role !== UserRoleEnum.MUNICIPAL_OPERATOR) {
      client()
        .query({
          query: GET_CUSTOMER_CASES,
        })
        .then((results) => {
          if (
            results &&
            results.data &&
            results.data.getCustomer &&
            results.data.getCustomer.cases &&
            results.data.getCustomer.cases.elements
          ) {
            setCases(
              results.data.getCustomer.cases.elements.map(
                ({
                   caseId,
                   caseNumber,
                   contract,
                   draft,
                   draftAsJson,
                   issueDate,
                   status,
                   subType,
                   type,
                   path,
                 }) => {
                  return {
                    caseId: caseNumber,
                    current_caseId: caseId,
                    current_status: status,
                    current_type: type ? type : subType,
                    issueDate,
                    status,
                    subType,
                    type: type ? type : subType,
                    draftAsJson,
                    draft,
                    path,
                    contractId: contract.contractId || "",
                    ownerName:
                      (contract.accountHolder.name || "") + ' ' +
                      (contract.accountHolder.surname || ""),
                    fiscalCode: contract.accountHolder.integraClientCode,
                  };
                }
              )
            );
          }
        })
        .catch((err) => console.log(err));
    } else {
      client()
        .query({
          query: GET_OPERATOR_CASES,
        })
        .then((results) => {
          if (
            results &&
            results.data &&
            results.data.getOperator &&
            results.data.getOperator.cases &&
            results.data.getOperator.cases.elements
          ) {
            setCases(
              results.data.getOperator.cases.elements.map(
                ({
                   caseId,
                   caseNumber,
                   type,
                   subType,
                   status,
                   contract,
                   issueDate,
                   operator,
                   draft,
                   path
                 }) => {
                  return {
                    caseId: caseNumber,
                    current_caseId: caseId,
                    current_operator_id: operator.id,
                    issueDate,
                    type: type ? type : subType,
                    current_status: status,
                    current_type: type ? type : subType,
                    status,
                    path,
                    ownerSurname: contract.accountHolder.surname || "",
                    fiscalCode: operator.email,
                    operatorId: operator.email,
                    draft,
                  };
                }
              )
            );
          }
        })
        .catch((err) => console.log(err));
    }
     **/
    // eslint-disable-next-line
  }, [removedItem]);
  return (
    <div className="ListCasePage" data-testid="ListCasePage">
      {getContent(role, cases, setOpenSelectCase, setRemovedItem, dataLoaded)}
      <div className="wrapper">
        <Modal
          show={openSelectCase}
          onClose={() => setOpenSelectCase(false)}
          content={
            <div>
              <ProviderCase role={role} setOpenSelectCase={setOpenSelectCase} />
            </div>
          }
        />
      </div>
    </div>
  );
};

ListCasePage.propTypes = {};

export default ListCasePage;
